import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../consts/api";

export const useCreateTimeTrackingGroup = (options = {}) => {
  const res = useMutation(
    (dto) =>
      http.post(
        HTTP_ENDPOINTS.timeclockSettings.createTimeTrackingGroups(),
        dto,
      ),
    {
      ...options,
    },
  );
  return res;
};
